import { useContext } from 'react'

import { FiltersContext } from '@provider/Shared/FiltersProvider'

import { IFiltersProps } from '@base/@types/providers/Shared/FiltersProvider'

export default function useFilters(): IFiltersProps {
  const context = useContext(FiltersContext)

  return context
}
